import React from 'react';

export default () => {
  // noinspection JSUnresolvedVariable
  const appVersion = APP_VERSION; // eslint-disable-line no-undef
  return (
    <div className="app-version">
      <span>{appVersion}</span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./book/src/commons/components/others/Version.jsx